import { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { apiErrorMessage, useVerifyEmail } from '../lib/api'
import { useAuth } from '../lib/auth'
import { AuthShell } from '../components/AuthShell'

export function VerifyEmailPage() {
  const { token } = useParams<{ token: string }>()
  const m = useVerifyEmail()
  const { user } = useAuth()

  useEffect(() => {
    if (token) m.mutate({ token })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const email = user?.email ?? 'your inbox'

  return (
    <AuthShell>
      <div className="auth-card auth-card--centered">
        <div className="auth-card__header">
          <div className="auth-card__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <polyline points="3 7 12 13 21 7" />
            </svg>
          </div>
          {token ? (
            <>
              <h1 className="auth-card__title">
                {m.isPending && 'Verifying your email…'}
                {m.isSuccess && 'Email verified'}
                {m.isError && 'Verification failed'}
              </h1>
              <p className="auth-card__subtitle">
                {m.isPending && 'One moment…'}
                {m.isSuccess && 'Your email is confirmed. You can now sign in.'}
                {m.isError && apiErrorMessage(m.error)}
              </p>
            </>
          ) : (
            <>
              <h1 className="auth-card__title">Check your email</h1>
              <p className="auth-card__subtitle">
                We sent a verification link to <span className="auth-card__email-highlight">{email}</span>. Click the
                link to confirm your address — it expires in 24 hours.
              </p>
            </>
          )}
        </div>

        <div className="auth-card__footer">
          <Link to="/login" className="auth-card__footer-link">Back to sign in</Link>
        </div>
      </div>
    </AuthShell>
  )
}
